import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=08ed9e84&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=08ed9e84&prod&lang=scss"
import style1 from "./AddUser.vue?vue&type=style&index=1&id=08ed9e84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed9e84",
  null
  
)

export default component.exports